import axios from 'axios';
import React, { useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';

const EnrollNow = () => {

    const [form, setFrom] = useState({
        name: '',
        phone: '',
        email: '',
        qualification: '',
    })
    const handleSubmit = (e) => {
        e.preventDefault()
        // Check if any field is empty
        if (!form.name || !form.phone || !form.email || !form.qualification) {
            toast.error("Please fill in all fields.");
            return; // Prevent form submission if fields are empty
        }

        // Validate email format
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(form.email)) {
            toast.error("Please enter a valid email address.");
            return;
        }

        // Validate phone number format (basic validation: must be digits and at least 10 characters long)
        const phoneRegex = /^\d{10,}$/;
        if (!phoneRegex.test(form.phone)) {
            toast.error("Please enter a valid phone number.");
            return;
        }

        // Sanitize inputs to prevent XSS and SQL injection
        const sanitizedForm = {
            name: sanitizeInput(form.name),
            phone: sanitizeInput(form.phone),
            email: sanitizeInput(form.email),
            qualification: sanitizeInput(form.qualification),
        };
        console.log(sanitizedForm)

        const id = toast.loading("Please wait...")

        axios.post('https://mindcoadmin.v4masters.com/public/index.php/enrollNow', sanitizedForm)
            .then((response) => {
                if (response.data === "success") {
                    toast.update(id, { render: "Your Application is Submitted", type: "success", autoClose: 3000, isLoading: false });
                    setTimeout(() => {
                        // window.location.reload()
                        setFrom({
                            name: '',
                            phone: '',
                            email: '',
                            qualification: ''
                        });
                    }, 3000)
                } else {
                    toast.update(id, { render: "Somthing Went Wrong", type: "error", autoClose: 3000, isLoading: false });
                }
            })
            .catch((error) => {
                toast.update(id, { render: "Somthing Went Wrong", type: "error", autoClose: 3000, isLoading: false });
            })
    }
    const sanitizeInput = (input) => {
        return input.replace(/<script.*?>.*?<\/script>/gi, '')
            .replace(/['";]/g, '')
            .replace(/<[^>]*>/g, '');
    };
    const handleFormInput = (e) => {
        const { name, value } = e.target;

        setFrom((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    return (
        <>
            <ToastContainer />
            <div className="container-fluid py-5 px-4 bg-light enroll">
                <div className="row p-md-5 align-content-center justify-content-around  ">
                    {/* Left Section */}
                    <div className="col-md-5 ">
                        <h1 className="display-5 text-danger fw-bold">Empower Your  Tech Career with Us</h1>
                        <p className="mt-4 text-secondary fs-5">
                            Chandigarh’s Leading <strong>Tech</strong> Training Institute.
                        </p>
                        <ul className="list-unstyled fs-5">
                            <li className="mb-2"><span className="text-danger me-2">•</span>100% Guaranteed Placement</li>
                            <li className="mb-2"><span className="text-danger me-2">•</span>Expert-Led On-Site Training</li>
                            <li className="mb-2"><span className="text-danger me-2">•</span>Money-Back Guarantee</li>
                            <li className="mb-2"><span className="text-danger me-2">•</span>24/7 Assistance</li>
                            <li className="mb-2"><span className="text-danger me-2">•</span>Act Now - Spots Filling Fast!</li>
                        </ul>
                        <p className="mt-4 fw-bold fs-5">
                            Join mclschool to be career-ready. Limited seats available.
                        </p>
                    </div>
                    {/* Right Section */}
                    <div className="col-md-5">
                        <div className="card p-4 shadow">
                            <h4 className="fw-bold text-center mb-2">Fill in the form below</h4>
                            <p className="text-center text-dark mb-4 fs-4">Our mentors will connect with you within 24 hours.</p>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="fullName" className="form-label">Full Name*</label>
                                    <input type="text" name='name' onChange={handleFormInput} value={form.name} className="form-control" id="fullName" placeholder="Enter your full name" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="phoneNumber" className="form-label">Phone Number*</label>
                                    <input type="tel" name='phone' onChange={handleFormInput} value={form.phone} className="form-control" maxLength={10} id="phoneNumber" placeholder="Enter your phone number" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Email ID*</label>
                                    <input type="email" name='email' onChange={handleFormInput} value={form.email} className="form-control" id="email" placeholder="Enter your email" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="qualification" className="form-label">Highest Qualification*</label>
                                    <select className="form-select" onChange={handleFormInput} name='qualification' value={form.qualification} id="qualification" >
                                        <option value disabled defaultValue={''}>Select your qualification</option>
                                        <option value="currently-pursuing">Currently Pursuing Degree</option>
                                        <option value="bachelors">Bachelor's Degree</option>
                                        <option value="masters">Master's Degree</option>
                                        <option value="others">Others</option>
                                    </select>
                                </div>
                                <div className="d-grid">
                                    <button type="submit" className="btn btn-danger btn-lg">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default EnrollNow